const initialState = false;

const hasScrollReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'scroll/add':
			return true;
		case 'scroll/delete':
			return initialState;
		default:
			return state !== undefined ? state : null;
	}
};

export default hasScrollReducer;
